import React, { Component } from "react";
import { Button, Card, Dropdown, FormControl, Modal } from "react-bootstrap";
import { Checkbox, FormControlLabel, FormGroup, Grid } from "@material-ui/core";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import L from "leaflet";
import { MapContainer, TileLayer, LayersControl, GeoJSON } from "react-leaflet";
import hash from "object-hash";
import Axios from "../../redux/axiosHandlerGeo";
import{Link} from 'react-router-dom';
import GeoJsonLayer from "./GeoJsonLayer";
import { infastructure, gaupalika, ward } from "../../variable/global";
import { totalWard } from "../../variable/config";
import "leaflet/dist/leaflet.css";
import { connect } from "react-redux";
import {MdZoomOutMap} from 'react-icons/md'
import "../../assets/css/map/map.scss";
class EmergencyContactModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			sections: [],
		};
	}
	componentDidMount() {
		let sections = [
			{
				title: "",
				numbers: [
					{
						title: "बरुण यन्त्र (वडा नं. १८)",
						value: "९७४९ ५१४०५५ , ०९९ -५२२३११",
					},
					{
						title: "सेफर हस्पिटल, वडा नं.  ०४",
						value: "०९९-५२०८०५",
					},
					{
						title: "महाकाली अञ्चल अस्पताल, वडा नं. १८",
						value: "०९९-५२११११",
					},
					{
						title: "झलारी आयुर्बेद औषधालय	 शु.न.१० झलारी",
						value: "०९९-५४०३१६",
					},
				],
			},
			{
				title: "एम्बुलेन्स सेवा प्रदायक संस्था",
				numbers: [
					{
						title: "महाकली अं.अस्पताल वडा १८",
						value: "९८४८८३३३१७",
					},
					{
						title: "ने.रेडक्रस सोसाइटि जि.क.पु.शाखा	",
						value: "९८६८७३७६२१",
					},
					{
						title: "नेपाल रेडक्रस सोसाईटि उप शाखा एरी कंचनपुर",
						value: "९८६८७२७३७४",
					},
					{
						title: "हाडासैनी परोपकार सेवा समिति	",
						value: "९८४९१५१२०७, ९८५८७५००७४",
					},
					{
						title: "निङ्गलासैनी भगवती सेवा",
						value: "९८६५०९९०७०",
					},
					{
						title: "जिमुवा हेल्थ पोष्ट जिमुवा",
						value: "९८६५९४१०७७ ",
					},
				],
			},
			{
				title: "प्रहरी सम्पर्क कार्यालय",
				numbers: [
					{
						title: "जिल्ला प्रहरी कार्यालय",
						value: "९८५८७३५५५५, ९८५८७५०९१७, ०९९-५२१२००",
					},
					{
						title: "जिल्ला प्रशासन, जी प्र का",
						value: "९८५८७३७७७७,  ०९९-५२०७०८",
					},
					{
						title: "सिमा प्रहरी चौकी , सिमा ब्रमदेव",
						value: "९८५८७९०४१४",
					},
					{
						title: "सिमा प्रहरी चौकी, बागलफाट",
						value: "९८५८७९०४१७",
					},
					{
						title: "सिमा प्रहरी चौकी, झोलुंगे",
						value: "९८५८७९०४२५ ",
					},
					{
						title: "जिमुवा हेल्थ पोष्ट जिमुवा",
						value: "९८६५९४१०७७ ",
					},
					{
						title: "इलाका प्रहरी , गड्डा  चौकीे",
						value: "९८५८७९०४०८ ",
					},
					{
						title: "COVID -19 Emergency Contact, Municipality",
						value: "९८६५९४१०७७ ",
					},
				],
			},
		];
		this.setState({ sections });
	}
	renderContacts() {
		return (
			<>
				{this.state.sections.map((section, secIndex) => {
					return (
						<div key={secIndex}>
							{section.title ? (
								<>
									<h3 className="font-weight-bolder mb-4 mt-4">
										{section.title}
									</h3>
								</>
							) : null}
							<div className="row">
								{section.numbers.map((number, numIndex) => {
									return (
										<div
											className="col-lg-6 d-flex flex-wrap mb-4"
											key={numIndex}
										>
											<h5 className="font-weight-bold mr-2">
												{number.title} :{" "}
											</h5>
											<h5 className="text-primary font-weight-bold">
												{number.value}
											</h5>
										</div>
									);
								})}
							</div>
						</div>
					);
				})}
			</>
		);
	}
	render() {
		return (
			<Modal
				{...this.props}
				size="xl"
				aria-labelledby="contained-modal-title-vcenter"
				centered
				closeButton
			>
				<Modal.Body className="p-md-15">
					<div className="d-flex justify-content-between mb-6">
						<h1 className="font-weight-bolder">
							<i className="icon-emergency text-primary display-4"></i> आपतकालीन
							सम्पर्क
						</h1>
						<i className="fa fa-times" onClick={this.props.onHide}></i>
					</div>
					{this.renderContacts()}
				</Modal.Body>
			</Modal>
		);
	}
}
class MapSection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modalShow: false,
			boundData: [],
			location: {
				lat: 27.938571,
				lng: 85.918619,
			},
			zoom: 11,
			checkbox: {
				economic: false,
			},
			wholeGeoJSON: {},
			showGeoJSON: [],
			wardCheckAll: true,
			indeterminateWard: false,
			// wardSelected: [],
			wardSelected: [...Array(totalWard).keys()].map((each) => each + 1),
		};
		this.getMunicpalId = this.getMunicpalId.bind(this);
	}

	isGeoJsonAlreadyFetched = (field) => {
		const { wholeGeoJSON } = this.state;
		//console.log("Geo json field", field);
		//console.log("Geo json", wholeGeoJSON);
		//console.log("Geo json fetched", wholeGeoJSON[field]);

		return Boolean(field in wholeGeoJSON);
	};

	fetchGeoJSON = (changedData) => {
		//console.log("fetch", changedData);
		const body = {
			ward: "fetch/ward",
			// private: "institute/private",
			// community: "institute/community",
			// madrasa: "institute/madrasa",
			montessori: "institute/montessori",
			primary: "institute/primary",
			secondary: "institute/secondary",
			// gumba: "institute/gumba",
			college_nontechnical: "institute/college_nontechnical",
			college_technical: "institute/college_technical",
			university: "institute/university",
			skill_center: "institute/skill_center",
			hospital: "institute/hospital",
			healthPost: "institute/healthPost",
			swasthya_ikaai: "institute/swasthya_ikaai",
			primary_heath_center: "institute/primary_heath_center",
			basic_health_center: "institute/basic_health_center",
			urban_helath_center: "institute/urban_helath_center",
			village_clinic: "institute/village_clinic",
			helpdesk: "institute/helpdesk",
			maternity: "institute/maternity",
			clinic: "institute/clinic",
			ayurved: "institute/ayurved",
			natural_hospital: "institute/natural_hospital",
			bridge: "institute/bridge",
			stadium: "institute/stadium",
			powerhouse: "institute/powerhouse",
			community_building: "institute/community_building",
			powerstation: "institute/powerstation",
			airport: "institute/airport",
			fm_station: "institute/fm_station",
			tv_station: "institute/tv_station",
			tower: "institute/tower",
			internet_provider: "institute/internet_provider",
			calvert: "institute/calvert",
			water_tank: "institute/water_tank",
			sabhaa_hal: "institute/sabhaa_hal",
			sabdahaa_sthal_1: "institute/sabdahaa_sthal_1",
			animal_cut: "institute/animal_cut",
			a: "institute/a",
			b: "institute/b",
			c: "institute/c",
			d: "institute/d",
			public_toilet: "institute/public_toilet",
			free_wifi: "institute/free_wifi",
			buspark: "institute/buspark",
			park: "institute/park",
			chautaara: "institute/chautaara",
			paati_pauwaa: "institute/paati_pauwaa",
			zoo: "institute/zoo",
			land_revenue: "institute/land_revenue",
			dao: "institute/dao",
			court: "institute/court",
			ministries: "institute/ministries",
			electricity: "institute/electricity",
			dcc: "institute/dcc",
			other_government: "institute/other_government",
			ngo: "institute/ngo",
			ingo: "institute/ingo",
			brick_industry: "institute/brick_industry",
			sugar_mill: "institute/sugar_mill",
			mill: "institute/mill",
			other_industry: "institute/other_industry",
			police: "institute/police",
			apf: "institute/apf",
			army: "institute/army",
			traffic: "institute/traffic",
			mining: "institute/mining",
			waterfall: "institute/waterfall",
			cave: "institute/cave",
			lake: "institute/lake",
			pond: "institute/pond",
			main_water_source: "institute/main_water_source",
			others: "institute/others",
			temple: "institute/temple",
			mosque: "institute/mosque",
			gumba: "institute/gumba",
			dharmasala: "institute/dharmasala",
			museum: "institute/museum",
			palace: "institute/palace",
			cultural_club: "institute/cultural_club",
			forest: "institute/forest",
			homehotell: "institute/homehotell",
			resort: "institute/resort",
			homesty: "institute/homesty",
			resturent: "institute/resturent",
			palika_related_office: "institute/palika_related_office",
		};

		return new Promise((resolve, reject) => {
			// //console.log("axiosUpper", body[changedData]);

			Axios.get(`/api/geojson/${body[changedData]}`)
				.then((result) => {
					let wholeGeoJSON = this.state.wholeGeoJSON;
					// wholeGeoJSON[changedData] = result.data;
					this.setState(
						{
							wholeGeoJSON: {
								...wholeGeoJSON,
								[changedData]: result.data,
							},
						},
						this.arrangeAllOption
					);
				})
				.catch((err) => reject());
		});
	};

	arrangeAllOption = async () => {
		const { checkbox, wardSelected, wardCheckAll } = this.state;
		//console.log("State:", this.state);
		//console.log("Ward selected", wardSelected);
		const showGeoJSON = [];

		if (!this.isGeoJsonAlreadyFetched("ward")) await this.fetchGeoJSON("ward");
		showGeoJSON.push(
			wardSelected.map((each) => this.state.wholeGeoJSON.ward[each - 1])
		);

		let dataToCheck = [];

		dataToCheck = dataToCheck.concat(infastructure);
		//console.log("dataToCheck", dataToCheck);
		const data = dataToCheck.map(async (each, i) => {
			if (each.children) {
				each.children.map(async (child) => {
					if (checkbox[child.value]) {
						//console.log("Checkbox", checkbox[child.value]);
						if (!this.isGeoJsonAlreadyFetched(child.value))
							await this.fetchGeoJSON(child.value);
						if (wardCheckAll)
							showGeoJSON.push(this.state.wholeGeoJSON[child.value]);
						else
							wardSelected.map((eachWard) => {
								//console.log("ewar", eachWard);
								showGeoJSON.push(
									Object.values(this.state.wholeGeoJSON[child.value]).filter(
										(eachType) => eachType.wardNo === eachWard
									)
								);
							});
					}
				});
			} else {
				if (checkbox[each.value]) {
					//console.log("Checkbox", checkbox[each.value]);
					if (!this.isGeoJsonAlreadyFetched(each.value))
						await this.fetchGeoJSON(each.value);

					if (wardCheckAll)
						showGeoJSON.push(this.state.wholeGeoJSON[each.value]);
					else
						wardSelected.map((eachWard) => {
							showGeoJSON.push(
								this.state.wholeGeoJSON[each.value].filter(
									(eachType) => eachType.wardNo === eachWard
								)
							);
						});
				}
			}
		});
		// wait until all promises resolve
		await Promise.all(data);
		this.setState({ showGeoJSON });
	};

	onCheckAllWardChange = (e) => {
		this.setState(
			{
				wardSelected: e.target.checked
					? [...Array(totalWard).keys()].map((each) => each + 1)
					: [],
				indeterminateWard: false,
				wardCheckAll: e.target.checked,
			},
			this.arrangeAllOption
		);
	};

	handleWardChange = (checkedValue) => {
		let wardSelected;
		let checkedValueInt = parseInt(checkedValue);
		if (this.state.wardSelected.includes(checkedValueInt)) {
			wardSelected = this.state.wardSelected.filter(
				(i) => i !== checkedValueInt
			);
		} else {
			wardSelected = [...this.state.wardSelected, checkedValueInt];
		}
		//console.log("wardarr", wardSelected);
		this.setState(
			{
				wardSelected,
				indeterminateWard:
					!!checkedValue.length &&
					checkedValue.length > 0 &&
					checkedValue.length < totalWard,
				wardCheckAll: checkedValue.length === totalWard,
			},
			this.arrangeAllOption
		);
		//console.log(this.state.wardSelected);
	};

	handleChange = (e) => {
		e.persist();
		//console.log("event", e.target.name);
		this.setState(
			({ checkbox }) => ({
				checkbox: {
					...checkbox,
					[e.target.name]: e.target.checked,
				},
			}),
			this.arrangeAllOption
		);
		//console.log(this.state);
	};

	style(feature) {
		let skin = "blue";
		if (feature.properties.FIRST_GaPa === "Bhimdatta") {
			skin = "green";
		}
		return {
			fillColor: skin,
			weight: 1,
			opacity: 1,
			color: "black",
			fillOpacity: 0.3,
		};
	}

	componentDidMount() {
		const boundData = [
			{
				key: "पुर्व",
				value: "वेद्कोट नगरपालिका",
				class: "col-md-6",
			},
			{
				key: "उत्तर",
				value: "चीन",
				class: "col-md-6",
			},
			{
				key: "पश्चिम",
				value: "महाका`ी नदी",
				class: "col-md-6",
			},
			{
				key: "दक्षिण",
				value: "शुïाफाँटा राîíय निकुन्ज",
				class: "col-md-6",
			},
			{
				key: "क्षत्रफ",
				value: "1७१.३४ व कि.मि.",
				class: "col-md-6",
			},
			{
				key: "वडा ख्या",
				value: "19",
				class: "col-md-6",
			},
			{
				key: "अक्षां तथा देशान्तर",
				value: "37.0902° N, 95.7129° W",
				class: "col-12",
			},
			{
				key: "मुख्य सहरी क्षेत्र",
				value: "",
				class: "col-12",
			},
		];
		this.setState({ ...this.state, boundData });
		setTimeout(() => {
			let evt = {
				target: {
					checked: true,
				},
			};
			this.onCheckAllWardChange(evt);
		}, 2000);
	}
	getMunicipalBounds() {
		let modalClose = () => this.setState({ modalShow: false });
		return (
			<div className="col-lg-5 pb-5 d-flex align-items-stretch">
				<Card>
					<Card.Body>
						<div className="d-flex pb-8">
							<SVG
								className="primary-icon"
								src={toAbsoluteUrl("media/hamropalika/svg/map_marker.svg")}
								alt=""
							/>
							<h2 className="font-weight-black pl-3 pt-6">सिमाना</h2>
						</div>
						<div className="row">
							{this.state.boundData.map((data, index) => {
								return (
									<div className={`pb-3 ${data.class}`} key={index}>
										<div className="d-flex">
											<h5 className="pr-2">{data.key}:</h5>
											<h5 className="text-primary">{data.value}</h5>
										</div>
									</div>
								);
							})}
						</div>
						<div className="float-right ">
							<Button
								className="px-10 emergency-button"
								variant="light-danger"
								size="lg"
								onClick={() => this.setState({ modalShow: true })}
							>
								{" "}
								<i className="icon-emergency"></i> आपतकालीन सम्पर्क
							</Button>

							<EmergencyContactModal
								show={this.state.modalShow}
								onHide={modalClose}
							/>
						</div>
					</Card.Body>
				</Card>
			</div>
		);
	}
	getMunicpalId() {
		return (
			<div className="map-section">
				<MapContainer
					style={{ height: "550px"}}
					center={this.state.location}
					zoom={this.state.zoom}
					minZoom="11"
				>
					<TileLayer
						url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
						attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
					/>

					{/* {this.state.showGeoJSON.length > 0 &&
						this.state.showGeoJSON.map((each) => {
							return (
								each.length > 0 &&
								Object.values(each).map((eachGeoJSON, index) => {
									if (eachGeoJSON)
										return ( */}
											<GeoJsonLayer
											showGeoJSON={this.state.showGeoJSON}
												// type={eachGeoJSON.type}
												// key={index}
												// style={eachGeoJSON.style}
												// data={eachGeoJSON.geoJson}
											/>
						<div id="map-view">
							<Link to="/MapDetailPage" target="_blank" >
								<MdZoomOutMap />
							</Link>
						</div>
						
						
						
				</MapContainer>
			</div>
			// <div className="col-lg-12 pb-5 d-flex align-items-stretch">
			//     <Card>
			//         <Card.Body>

			//             {/* boundary map goes here */}
			//             {/* <p className="mun-id-desc">
			//                 सुदूरपश्चिम प्रदेश (तत्कालिन सुदूरपश्चिमाञ्चल विकास क्षेत्रमा पर्ने महाकाली अञ्चल), कञ्चनपुर जिल्लाको सदरमुकामको रुपमा भीमदत्त नगरपालिका राजधानी काठमाडौंबाट ७५० कि.मी. को दुरीमा रहेको छ । कंचनपुर जील्लामा भएका ९ स्थानिय तहमा सात वटा नगरपालिका मध्ये सबैभन्दा जेठो नगरपालिका हो। तत्कालिन महेन्द्रनगर पञ्चायतको रुपमा वि.सं. २०३४ सालमा भूजेला,सिद्धनाथ र आदर्श गाँउ पञ्चायतका सम्पुर्ण भाग तथा सुडा र ऐरी गाँउ पञ्चायतको आंशिक भू-भाग मिलाई गठन भएको हो । महेन्द्रनगर नामाकरण गर्नुपुर्व यसको बजार क्षेत्रलाई धुसुडी बजार भनिन्थ्यो । वि.सं. २०४७ सालको जनआन्दोलन पश्चात महेन्द्रनगर नगरपञ्चायत बाट नाम परिवर्तन गरी महेन्द्रनगर नगरपालिका बनाइयो र वि.सं. २०६५ साल कार्तिक २० गतेको नेपाल सरकार मन्त्रि परिषदको निर्णयानुसार (शहिद भीमदत्त पन्तको सम्मानस्वरुप उहाँको नाममा) यस नगरपालिकालाई भीमदत्त नगरपालिका नामाकरण गरियो ।
			//             </p> */}
			//         </Card.Body>
			//     </Card>
			// </div>
		);
	}
	// render() {
	//     return (
	//         <>
	//             <div className="row">
	//                 {this.getMunicpalId()}
	//                 {/* {this.getMunicipalBounds()} */}
	//             </div>
	//         </>
	//     );
	// }
	getDropdownIcon = (icon) => {
		return (
			<img
				className="mr-3"
				src={toAbsoluteUrl(`/media/hamropalika/png-icons/${icon}.png`)}
				alt=""
			/>
			// <span className="icon-container mr-3" style={{ backgroundColor: "#FFF4DE" }}>
			//     <i className="icon-ic-borrowed-books" style={{
			//         color: '#FFA800',
			//     }}></i>
			// </span>
		);
	};
	getDropdownContent = () => {
		return infastructure.map((category) => {
			return (
				<>
					<div className="d-flex justify-content-start mb-2">
						{category.icon && this.getDropdownIcon(category.icon)}
						{!category.value && (
							<Dropdown className="mt-2 w-100">
								<Dropdown.Toggle
									variant="outline-secondary"
									id="map-filter-dropdown"
									className="text-left"
									block
								>
									{this.props.selectedLanguage == "nepali"
										? category.nepali
										: category.english}
								</Dropdown.Toggle>

								<Dropdown.Menu>
									{category.children &&
										category.children.map((child) => (
											<Dropdown.Item onClick={(e) => e.stopPropagation()}>
												<FormControlLabel
													control={
														<Checkbox
															name={child.value}
															onChange={(e) => this.handleChange(e)}
															checked={this.state.checkbox[child.value]}
															value="checkedA"
														/>
													}
													label={
														this.props.selectedLanguage == "nepali"
															? child.nepali
															: child.english
													}
												/>
											</Dropdown.Item>
										))}
								</Dropdown.Menu>
							</Dropdown>
						)}
						{category.value && (
							<FormControlLabel
								control={
									<Checkbox
										name={category.value}
										onChange={(e) => this.handleChange(e)}
										checked={this.state.checkbox[category.value]}
										value="checkedA"
									/>
								}
								label={
									this.props.selectedLanguage == "nepali"
										? category.nepali
										: category.english
								}
							/>
							// <Dropdown className="mt-2 ">
							//     <Dropdown.Toggle variant="outline-secondary" id="map-filter-dropdown">
							//         {this.props.selectedLanguage == "nepali" ? category.nepali : category.english}
							//     </Dropdown.Toggle>

							//     <Dropdown.Menu>
							//         {
							//             category.children && category.children.map((child) => (
							//                 <Dropdown.Item ></Dropdown.Item>
							//             )
							//             )
							//         }
							//     </Dropdown.Menu>
							// </Dropdown>
						)}
					</div>
				</>
			);
		});
	};
	getWardDropDown = () => {
		return (
			<>
				<div className="d-flex justify-content-start ml-18">
					{/* {this.getDropdownIcon("infrastructure")} */}

					<Dropdown className="mt-2 w-100">
						<Dropdown.Toggle
							variant="outline-secondary"
							id="map-filter-dropdown"
							className="text-left"
							block
						>
							{this.props.selectedLanguage == "nepali" ? "वडा" : "Ward"}
						</Dropdown.Toggle>

						<Dropdown.Menu>
							<Dropdown.Item onClick={(e) => e.stopPropagation()}>
								<FormControlLabel
									control={
										<Checkbox
											indeterminate={this.state.indeterminateWard}
											onChange={(e) => this.onCheckAllWardChange(e)}
											checked={this.state.wardCheckAll}
										></Checkbox>
									}
									label={gaupalika[this.props.selectedLanguage]}
								/>
							</Dropdown.Item>
							{ward.map((each) => (
								<Dropdown.Item>
									<FormControlLabel
										control={
											<Checkbox
												checked={this.state.wardSelected.includes(
													parseInt(each.value)
												)}
												value={parseInt(each.value)}
												onChange={(e) => this.handleWardChange(e.target.value)}
											/>
										}
										label={each[this.props.selectedLanguage]}
									/>
								</Dropdown.Item>
							))}
						</Dropdown.Menu>
					</Dropdown>
				</div>
			</>
		);
	};
	render() {
		return (
			<div className="row">
				<div className="col-12">
					<Card>
						<Card.Body>
							<div className="row">
								<div className="col-md-9">
									<div className="d-flex align-items-center my-5">
										<SVG
											width="52"
											height="52"
											className="primary-icon"
											src={toAbsoluteUrl(
												"media/hamropalika/svg/area-with-pins.svg"
											)}
											alt=""
										/>
										<h1 className="ml-3 mb-0">
											{this.props.selectedLanguage == "nepali"
												? "नक्शा"
												: "Map"}
										</h1>
									</div>
									{this.getMunicpalId()}
									{/* <a
										href={toAbsoluteUrl("/media/hamropalika/resource.zip")}
										target="_blank"
									>
										<button className="btn btn-light-primary mt-3 float-right">
											Download Resource Map
										</button>
									</a> */}

									{/* <div className="map-section">
                                        <MapContainer
                                            style={{ height: "50vh" }}
                                            center={this.state.location}
                                            zoom={this.state.zoom}
                                        >
                                            <TileLayer
                                                url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
                                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                            />

                                            {this.state.showGeoJSON.length > 0 &&
                                                this.state.showGeoJSON.map((each) => {
                                                    return (
                                                        each.length > 0 &&
                                                        each.map((eachGeoJSON) => {
                                                            if (eachGeoJSON)
                                                                return (
                                                                    <GeoJsonLayer
                                                                        type={eachGeoJSON.type}
                                                                        key={eachGeoJSON.name}
                                                                        style={eachGeoJSON.style}
                                                                        data={eachGeoJSON.geoJson}
                                                                    />
                                                                );
                                                        })
                                                    );
                                                })}
                                            <GeoJSON
                                                key={hash(this.state.wholeGeojson)}
                                                data={this.state.wholeGeojson}
                                            />
                                        </MapContainer>
                                    </div> */}
								</div>
								<div className="col-md-3">
									<div className="d-flex align-items-center my-5">
										<SVG
											width="45"
											height="45"
											className="primary-icon"
											src={toAbsoluteUrl("media/hamropalika/svg/filter.svg")}
											alt=""
										/>
										<h1 className="ml-3 mb-0">
											{this.props.selectedLanguage == "nepali"
												? "फिल्टर"
												: "Filters"}
										</h1>
									</div>
									<div className="row mt-2">
										<div className="col-12">
											<div style={{ height: "605px", overflowX: "auto" }}>
												{this.getWardDropDown()}
												{this.getDropdownContent()}
												{/* <FormControlLabel
													control={
														<Checkbox
															indeterminate={this.state.indeterminateWard}
															onChange={(e) => this.onCheckAllWardChange(e)}
															checked={this.state.wardCheckAll}
														></Checkbox>
													}
													label={gaupalika[this.props.selectedLanguage]}
												/>
												<FormGroup>
													{ward.map((each) => (
														<FormControlLabel
															control={
																<Checkbox
																	checked={this.state.wardSelected.includes(
																		parseInt(each.value)
																	)}
																	value={parseInt(each.value)}
																	onChange={(e) =>
																		this.handleWardChange(e.target.value)
																	}
																/>
															}
															label={each[this.props.selectedLanguage]}
														/>
													))}
												</FormGroup> */}
											</div>
										</div>
									</div>
								</div>
							</div>
						</Card.Body>
					</Card>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	selectedLanguage: state.ward.selectedLanguage,
});
export default connect(mapStateToProps)(MapSection);
